exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.testCapitalize{text-transform:capitalize\n}\n.z-index-3000{z-index:3000 !important\n}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build@2/frontend/common-v2/components/Ellipsis.vue"],"names":[],"mappings":";AACA,gBAAgB,yBAAyB;CACxC;AACD,cAAc,uBAAuB;CACpC","file":"Ellipsis.vue","sourcesContent":["\n.testCapitalize{text-transform:capitalize\n}\n.z-index-3000{z-index:3000 !important\n}"],"sourceRoot":""}]);

// exports
